import { usePromise } from "~/promise";
import { useKeybanClient } from "~/provider";

/**
 * Retrives application details.
 * @returns - The result containing the application or an error.
 */
export function useKeybanApplication() {
  const client = useKeybanClient();

  return usePromise("application", () => client.api.application.getCurrent(), {
    suspense: true,
  });
}
